import client from "@culturehq/client";

const useStoryQuestions = () => ({
  getStoryQuestions: client.getStoryQuestions
});

export default useStoryQuestions;
